import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "@phosphor-icons/react";
import { Logo } from "../components/Logo";

const Section = ({ title, children }) => (
  <div className="mt-6">
    <h2 className="text-base font-bold text-[#0A1128]">{title}</h2>
    <div className="mt-1.5 space-y-2 text-sm leading-relaxed text-[#4A5568]">{children}</div>
  </div>
);

export default function Datenschutz() {
  const navigate = useNavigate();
  return (
    <div className="mx-auto min-h-screen max-w-md bg-[#F8F9FA]" data-testid="datenschutz-page">
      <div className="flex items-center justify-between px-6 pb-2 pt-[calc(env(safe-area-inset-top)+1.5rem)]">
        <button data-testid="back-btn" onClick={() => navigate(-1)} className="flex h-10 w-10 items-center justify-center rounded-full text-[#0A1128] transition-colors hover:bg-black/5">
          <ArrowLeft size={22} />
        </button>
        <Logo />
        <div className="w-10" />
      </div>

      <div className="px-7 pb-16 pt-6">
        <div className="mb-1 h-px w-12 bg-[#C5A059]" />
        <h1 className="font-display text-4xl font-light tracking-tight text-[#0A1128]">Datenschutz</h1>

        <div className="mt-4 rounded-xl border border-[#C5A059]/30 bg-[#FBF8F1] p-3 text-xs leading-relaxed text-[#8a6d2f]" data-testid="datenschutz-placeholder-hint">
          Hinweis: Diese Datenschutzerklärung ist eine sorgfältig erstellte Vorlage und ersetzt keine Rechtsberatung. Bitte vor der Veröffentlichung durch deinen Datenschutzbeauftragten bzw. eine Rechtsberatung final prüfen lassen.
        </div>

        <Section title="1. Verantwortlicher">
          <p>Verantwortlich für die Datenverarbeitung in diesem Empfehlungstool ist:</p>
          <p>Steffen Hermes<br />Lingener Str. 54<br />48531 Nordhorn<br />E-Mail: webmaster@empfehlungs-kompass.de<br />Website: https://empfehlungs-kompass.de</p>
        </Section>

        <Section title="2. Welche Daten wir verarbeiten">
          <p>Je nach Nutzung verarbeiten wir:</p>
          <p>• Kontaktdaten der empfohlenen Person (Name, ggf. Telefon/E-Mail), die du eingibst<br />
             • deine E-Mail-Adresse zur Anmeldung per Einmal-Code<br />
             • Status- und Verlaufsdaten zur Empfehlung<br />
             • technische Daten (z. B. Zeitpunkt der Zustimmung)</p>
        </Section>

        <Section title="3. Zweck & Rechtsgrundlage">
          <p>Die Verarbeitung dient der Durchführung des Empfehlungsprozesses und der Kontaktaufnahme mit der empfohlenen Person. Rechtsgrundlage ist die Einwilligung (Art. 6 Abs. 1 lit. a DSGVO) sowie die Durchführung vorvertraglicher Maßnahmen (Art. 6 Abs. 1 lit. b DSGVO).</p>
        </Section>

        <Section title="4. Zustimmung vor Kontaktaufnahme">
          <p>Eine empfohlene Person wird erst kontaktiert, nachdem sie ihre Zustimmung ausdrücklich bestätigt hat. Ohne Bestätigung erfolgt keine weitere Verarbeitung oder Kontaktaufnahme.</p>
        </Section>

        <Section title="5. Speicherdauer">
          <p>Wir speichern personenbezogene Daten nur so lange, wie es für den jeweiligen Zweck erforderlich ist. Empfehlungsdaten werden gelöscht, sobald die Empfehlung abgeschlossen ist oder die Einwilligung widerrufen wird; Anmelde- und Verlaufsdaten, sobald sie nicht mehr benötigt werden. Gesetzliche Aufbewahrungspflichten bleiben unberührt.</p>
        </Section>

        <Section title="6. Empfänger / Auftragsverarbeiter">
          <p>Für das Hosting nutzen wir die STRATO AG, Otto-Ostrowski-Straße 7, 10249 Berlin. Für den E-Mail-Versand kommen technische Dienstleister zum Einsatz. Diese sind als Auftragsverarbeiter nach Art. 28 DSGVO vertraglich zur Vertraulichkeit und DSGVO-Konformität verpflichtet. Eine Weitergabe an Dritte zu anderen Zwecken erfolgt nicht.</p>
        </Section>

        <Section title="7. Deine Rechte">
          <p>Du hast das Recht auf Auskunft, Berichtigung, Löschung, Einschränkung der Verarbeitung, Datenübertragbarkeit sowie Widerspruch. Eine erteilte Einwilligung kannst du jederzeit mit Wirkung für die Zukunft widerrufen. Zudem besteht ein Beschwerderecht bei einer Aufsichtsbehörde.</p>
        </Section>

        <Section title="8. Kontakt">
          <p>Für Anliegen zum Datenschutz erreichst du uns unter: webmaster@empfehlungs-kompass.de.</p>
        </Section>
      </div>
    </div>
  );
}
